module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_suns_resort_black_vertical-8c328efc6528b7a87927ea16912eebc4.svg";